import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import YTplayer from './YTplayer';

import {modalStyle} from '../configs';

export default class VideoPopup extends Component {
    render () {
        return (
            <ReactModal isOpen={this.props.showPopup} onRequestClose={this.props.close} contentLabel="" style={modalStyle}>
                <div className="videowrapper">
                    <YTplayer ytId={this.props.videoId} autoplay={true}/>
                </div>
            </ReactModal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/videoPopup.js